import script from "./MomentSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./MomentSwiper.vue?vue&type=script&setup=true&lang=js"

import "./MomentSwiper.vue?vue&type=style&index=0&id=0e705862&lang=less&scoped=true"
import "./MomentSwiper.vue?vue&type=style&index=1&id=0e705862&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e705862"]])

export default __exports__